import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
import c from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, m, f, i, p) {
  return t(), o("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#F7F6EF",
        d: "M41.837 18.198c-1.255 0-2.438.258-3.472.77C37.59 13.897 33.158 10 27.84 10c-5.799 0-10.526 4.631-10.673 10.367A7.052 7.052 0 0 0 11 27.387c-.002 3.895 3.175 7.057 7.09 7.057h23.747c4.506 0 8.163-3.64 8.163-8.124s-3.657-8.122-8.163-8.122Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m27.84 8.75-.298.004c-5.93.145-10.815 4.634-11.537 10.41l-.018.157-.235.064a8.304 8.304 0 0 0-6.002 8.002c-.003 4.586 3.735 8.307 8.34 8.307h23.747c5.195 0 9.413-4.198 9.413-9.374s-4.218-9.372-9.413-9.372l-.361.006a9.439 9.439 0 0 0-2.08.302l-.124.034-.072-.24c-1.518-4.845-6.082-8.3-11.36-8.3Zm0 2.5c4.652 0 8.6 3.396 9.29 7.908a1.25 1.25 0 0 0 1.79.93c.85-.421 1.841-.64 2.917-.64 3.817 0 6.913 3.08 6.913 6.872 0 3.793-3.096 6.874-6.913 6.874H18.089c-3.225 0-5.84-2.603-5.839-5.807a5.802 5.802 0 0 1 5.074-5.78 1.25 1.25 0 0 0 1.093-1.208c.13-5.072 4.316-9.149 9.423-9.149ZM15.074 41.947a1.25 1.25 0 0 1 2.033 1.45l-.08.11-.483.606a1.25 1.25 0 0 1-2.033-1.449l.08-.11.483-.607Zm13.397 0a1.25 1.25 0 0 1 2.033 1.45l-.08.11-.484.606a1.25 1.25 0 0 1-2.032-1.449l.08-.11.483-.607Zm14.615 0a1.25 1.25 0 0 1 2.032 1.45l-.079.11-.484.606a1.25 1.25 0 0 1-2.033-1.449l.08-.11.484-.607ZM23.6 48.007a1.25 1.25 0 0 1 2.032 1.45l-.079.111-.484.606a1.25 1.25 0 0 1-2.033-1.45l.08-.11.484-.606Zm12.178 0a1.25 1.25 0 0 1 2.033 1.45l-.08.111-.483.606a1.25 1.25 0 0 1-2.033-1.45l.08-.11.483-.606Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ c(a, [["render", r]]);
export {
  _ as default
};
